export default __webpack_public_path__ + "074964eac0de47dab303181f5998a88d.png";